/**
 * @module
 * @category Data
 */

import { SocialAccount } from '@bomdisoft/components';

export const socialAccounts: SocialAccount = {
  email: 'support@workadabra.com',
  facebook: 'https://www.facebook.com/workadabra',
  instagram: 'https://www.instagram.com/workadabra',
  linkedin: 'https://linkedin.com/company/workadabra',
  mobile: '+237 6 8338 0370',
  x: 'https://x.com/bomdisoft',
};
